(function () {
  function initializeDiscountHandle() {
    const discount_input = document.querySelector(".input-discount");
    const discount_delete = document.querySelector(".delete-discount");
    const discount_action = document.querySelector(".discount-field button");
    const discount_container = document.querySelector(".discount-row");
    const discount_message = document.querySelector(".discount-dislaimer");

    async function removeDiscountCode() {
      console.log("DEBUG removeDiscountCode:start", {
        cookie: getCookie("discount_code"),
      });
      if (getCookie("discount_code")) {
        const cartJSON = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        if (cartJSON.discount_codes.length > 0) {
          if (
            cartJSON.discount_codes.some(
              (code) => code.code.toUpperCase() == getCookie("discount_code")
            )
          ) {
            console.log("DEBUG removeDiscountCode:clearing cart discount");
            await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                discount: "",
              }),
            });

            deleteCookie("discount_code");
            setDiscountState("reset");
            sessionStorage.removeItem("lastDiscountCode");
            currentDiscountPercentage = false;
            currentDiscountCollectionIds = null;
            calculateDiscounts();
            refreshCart();
            document.dispatchEvent(new CustomEvent("update-bundle-price"));
            console.log("DEBUG removeDiscountCode:done");
          }
        }
      }
      // //clear discount code hack
      // fetch("/discount/CLEAR");

      // setTimeout(function () {

      // }, 1000)
    }

    function errorDiscountCode(code) {
      console.log("DEBUG errorDiscountCode", code);
      setDiscountState("error", code);
      // var $container = $("*[data-discount='" + content + "']");
      // var msg = $container.find("error").attr("msg");
      // var error = msg.replace("[CODE]", "<b>" + code + "</b>");
      // $container.find("error").html(error);
      // $container.attr("error", 1).find(".dgs-cart-discount-remove").hide();
      // $container.find("input[data-type='dgs-discount-input']").focus().select();
      // $(".dgs-cartbar-eventbox-button[data-topnavi='code']").attr("data-status", "");
    }
    async function successDiscountCode(code) {
      console.log("DEBUG successDiscountCode:start", code);
      setDiscountState("success", code);

      sessionStorage.setItem("currentEventbox", "");

      await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          discount: code,
        }),
      });
      console.log("DEBUG successDiscountCode:cart updated", code);

      setcookie("discount_code", code);
      analyzeCart(cartJSON);
      console.log("DEBUG successDiscountCode:analyzeCart dispatched");

      // fetch('/discount/' + encodeURIComponent(code), { cache: "no-cache" }).then(function (response) {
      //     return response.text();
      // }).then(function (response) {

      //     // setcookie("discount_code_last", code);
      //     fetch('/cart.js').then((e) => e.json()).then((cartJson) => {
      //     });
      // });
    }

    function setDiscountState(state, code = "", preselected = false) {
      // console.log("DEBUG setDiscountState ", state, "code ", code)
      if (state == "error") {
        discount_container.classList.add("error");
        discount_container.classList.remove("success");
        discount_message.innerHTML = discount_message.dataset.error.replace(
          "[]",
          "<b>" + code + "</b>"
        );
        if (code == "") {
          discount_action.innerText = discount_action.dataset.activate;
          discount_action.disabled = true;
        } else {
          discount_action.innerText = discount_action.dataset.change;
          discount_action.disabled = false;
        }
      } else if (state == "success") {
        discount_container.classList.remove("error");
        discount_container.classList.add("success");
        discount_message.innerHTML = discount_message.dataset.valid.replace(
          "[]",
          "<b>" + code + "</b>"
        );
        if (code == getCookie("discount_code") && !preselected)
          discount_message.innerText =
            window.themeVariables.strings.discount_not_changed;
        discount_action.innerText = discount_action.dataset.change;
        discount_action.disabled = false;
      } else {
        discount_container.classList.remove("error");
        discount_container.classList.remove("success");
        discount_message.innerText = discount_message.dataset.msg;
        discount_action.disabled = true;
        discount_action.innerText = discount_action.dataset.activate;
      }
    }
    async function changeDiscountCode(code) {
      var codeInput = discount_input.value;
      var code = code ? code : codeInput;
      code = code.trim().toUpperCase();
      var discount_cookie = getCookie("discount_code");
      console.log("DEBUG changeDiscountCode", {
        code: code,
        discount_cookie: discount_cookie,
      });
      if (code == "" && discount_cookie) {
        console.log("DEBUG changeDiscountCode:branch removeDiscountCode");
        await removeDiscountCode();
        return true;
      }
      if (code == "") {
        console.log("DEBUG changeDiscountCode:branch error (empty)");
        setDiscountState("error");
        return false;
      }
      if (code == discount_cookie) {
        console.log("DEBUG changeDiscountCode:branch unchanged");
        setDiscountState("success", code);
        return true;
      }
      var checkCode = await validateOaceDiscountCode(code);
      console.log("DEBUG changeDiscountCode:oace validate", checkCode);
      if (!checkCode) {
        errorDiscountCode(code);
        return false;
      }
      await successDiscountCode(code);
      return true;
    }

    function handlePreSelected() {
      let code = getCookie("discount_code");
      code = code ? decodeURI(code).toUpperCase() : false;
      console.log("DEBUG handlePreSelected", code);
      if (code) {
        discount_input.value = code;
        setDiscountState("success", code, true);
      }
    }
    document.addEventListener("DOMContentLoaded", function () {
      handlePreSelected();
    });

    function handleInputChange(event) {
      //handle button state
      if (discount_input.value.length > 0) {
        discount_action.disabled = false;
      } else {
        discount_action.disabled = true;
      }
    }

    function initListeners() {
      handlePreSelected();
      analyzeCart(cartJSON);
      updateDiscountTextBadge();
      // console.log('init list')
      if (discount_input) {
        discount_input.addEventListener("input", handleInputChange);
        discount_input.addEventListener("keyup", (event) => {
          if (event.keyCode == 13) changeDiscountCode();
        });
      }
      if (discount_action) {
        discount_action.addEventListener("click", () => {
          changeDiscountCode();
        });
      }
      if (discount_delete) {
        discount_delete.addEventListener("click", () => {
          discount_input.value = "";
          changeDiscountCode(" ");
        });
      }
    }
    document.addEventListener("discount:changed", function () {
      handlePreSelected();
    });
    initListeners();
    "line-item:change,cart:change".split(",").forEach((_eventName) => {
      document.addEventListener(_eventName, function (event) {
        // console.log("DEBUG event ",_eventName,  event);
        if (_eventName == "line-item:change" && event.detail.skip) {
          return;
        }
        initListeners();
      });
    });

    "collection:update,variant:change".split(",").forEach((event) => {
      document.addEventListener(event, function (e) {
        // console.log('e ', e);
        calculateDiscounts();
      });
    });

    window.addEventListener("load", function () {
      notifyDiscount();
      var currentURL = getCurrentRedirect();
      if (currentURL.includes("open")) {
        var open = currentURL.split("open=");
        if (open[1] == "cartbar") {
          document.querySelector('a[aria-controls="cart-drawer"]').click();
        }
      }
    });
    // document.addEventListener('DOMContentLoaded', handleCheckout())
    // 'cart:refresh,cart:change'.split(',').forEach((eventname) => {
    //     window.addEventListener(eventname, function () { setTimeout(() => { handleCheckout(); }, 1000) });
    // })
    function handleCheckout() {
      // console.log('handleCheckout');
      if (document.querySelector('cart-drawer form[action="/cart"]')) {
        document
          .querySelector('cart-drawer form[action="/cart"]')
          .addEventListener("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
            go2checkout();
          });
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (window.oaceDiscountCheckDisabled) {
      // Flag no longer disables the field: code entry, validation and cart
      // apply stay active. It only skips the price preview/cart analysis via
      // the guards in analyzeCart/calculateDiscounts/loadDiscountPercentageFromOaceApi.
      console.log("DEBUG discount-handle:check disabled, field still active");
    }
    let discountInitialized = false;
    if (document.querySelector(".input-discount")) {
      initializeDiscountHandle();
    } else {
      // empty cart, wait for cart build
      function assignEvent() {
        setTimeout(function () {
          initializeDiscountHandle();
        }, 1000);
        document.removeEventListener("variant:add", assignEvent);
      }
      document.addEventListener("variant:add", assignEvent);
    }
  });
})();
